<template>
  <div class="home-page-bd">
    <div class="banner">
      <div class="item " v-for="(image, index) in dataList" :key="index">
        <transition name="fade">
          <div v-if="index === currentIndex">
            <img v-if="image.url" :src="image.url" style="height: 7rem;display: block;margin:0 auto;">
          </div>
        </transition>
        <transition name="slide-fade">
          <div v-if="index === currentIndex"
            style="color: white;z-index: 100;font-size: .44rem;line-height: .50rem;padding: 0.05rem .10rem;border-width: 0px;left: .23rem;top: 3.4rem;position: absolute;">
            <div style="width: 4rem;">{{ image.name }}</div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div v-if="image.show && !!image.info" class="image-info">
            <div>{{ image.info }}</div>
          </div>
        </transition>
      </div>

    </div>
    <div class="company-c">
      <Swipe :autoplay="3000" class="van-swip" touchable @change="onChange" :show-indicators="false">
        <swipe-item v-for="(imgs, index) in companyList" :key="index" @click="goCompany(imgs)">
          <img :src="imgs.companyImageList[0].url" style="width: 100%;">
        </swipe-item>
      </Swipe>

    </div>
    <div class="company-name" v-if="companyList[current]">
      <div v-if="lang==='zh'">
        {{ companyList[current].companyName }}
      </div>
      <div v-if="lang==='en'">
        {{ companyList[current].enCompanyName }}
      </div>
      <div v-if="lang==='ja'">
        {{ companyList[current].jaCompanyName }}
      </div>
    </div>
    <div class="item-wrap">
      <div class="item" :class="{ on: current === index }" v-for="(item, index) in companyList" :key="index"></div>
    </div>
    <div class="info-wrap" :style="'background:' + bdColor">
      <div class="info" :style="'font-size:' + filterFontSize(font.indexContentSize) + ';color:' + font.indexContentColor"
        v-html="detailCompanyInfo.content">
      </div>
      <div class="company-image">
        <img class="img" :src="indexConfig.companInfo.image[0].url" alt=""
          v-if="indexConfig.companInfo && indexConfig.companInfo.image.length !== 0">
      </div>
    </div>
    <div class="new-content">
      <div class="header-c" :style="'border-bottom: 2px solid ' + allColor + ';font-weight: 600;'">
        <div v-if="lang === 'zh'">行业新闻</div>
        <div v-if="lang === 'en'">Industry News</div>
        <div v-if="lang === 'ja'">業界ニュース</div>
      </div>
      <div class="news" v-for="(news, index) in newsList" :key="index" @click="getDetail(news)">
        <!-- <div style="min-height:50px;float:left">
								<div :style="'background:'+allColor" :class="[{left:indexConfig.newsTipType==='1'},{round:indexConfig.newsTipType==='2'},{smallRound:indexConfig.newsTipType==='3'}]"></div>
							</div> -->
        <div class="right">
          <div class="title"
            :style="'font-size:' + font.newsTitleSize + ';color:' + font.newsTitleColor + ';margin-bottom:16px'">
            {{ news.newsTitle }}</div>
          <!-- <div class="content" v-html="news.newsContent">
									
								</div> -->
        </div>
      </div>
      <div class="header-c" :style="'border-bottom: 2px solid ' + allColor + ';font-weight: 600;'">
        {{ indexConfig.newsTitle }}
      </div>
      <div class="news" v-for="(news) in newsList1"  @click="getDetail(news)" :key="news._id">
        <div class="right">
          <div class="title"
            :style="'font-size:' + font.newsTitleSize + ';color:' + font.newsTitleColor + ';margin-bottom:16px'">
            {{ news.newsTitle }}</div>
        </div>
      </div>
    </div>
    <div class="image-list">
      <!-- +indexConfig.newsRightImageWidth -->
      <div v-for="(item,index) in indexConfig.newsRightImage " class="one-img" :style="'width:47%'+'px;height:'+indexConfig.newsRightImageHeight+'px'">
        <img :src="item.url">
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Lazyload, Swipe, SwipeItem } from 'vant';

Vue.use(Lazyload);


export default {
  name: 'Main',
  props: {
    lang: {}
  },
  components: {
    Swipe,
    SwipeItem
  },
  data() {
    return {
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
      current: 0,
      dataList: [{ url: '' }],
      allColor: '#ff121e',
      bdColor: '',
      currentIndex: 0,
      timer: null,
      companyList: [],
      font: {},
      detailCompanyInfo: {},
      indexConfig: {},
      newsList: [],
      newsList1: [],
      pageConfigPageTotal: {
        total: null,
        pageSize: 10,
        pageNo: 1,
        pageTotal: null
      },
    }
  },
  computed: {
    prevIndex() {
      if (this.currentIndex == 0) {
        return this.dataList.length - 1;
      } else {
        return this.currentIndex - 1;
      }
    },
    //下一张
    nextIndex() {
      if (this.currentIndex == this.dataList.length - 1) {
        return 0;
      } else {
        return this.currentIndex + 1;
      }
    },

  },
  mounted() {
    this.initData()
    this.runInv()
  },
  watch:{
    "$route": "initData",
  },
  methods: {
    initData(){
      this.getImage()
      
      this.getCompanyList()
      this.getCompanyInfo()
      this.getFontConfig()
      this.fetchNews(0)
      this.fetchNews(1)
    },
    onChange(index) {
      this.current = index;
    },
    filterFontSize(item) {
      if (item && item.includes('px')) {
        return item.split('px')[0] / 100 + 'rem'
      } else {
        return item
      }
    },
    runInv() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex)
      }, 5000)
    },
    gotoPage(index) {
      this.currentIndex = index;

    },
    async fetchNews(type) {
      let data = {
        pageSize: 10,
        pageNo: this.pageConfigPageTotal.pageNo,
        language: this.lang,
        type: type
      }
      const res = await this.$http.post('newsList', data);

      if (type == 0) {
        this.newsList = res.data.list.slice(0, 4);
      } else if (type == 1) {
        this.newsList1 = res.data.list.slice(0, 4);
      }
      this.pageConfigPageTotal = {
        total: res.data.pageTotal,
        pageSize: res.data.pageSize,
        pageNo: res.data.pageNo,
        pageTotal: res.data.pageAcount
      }
    },
    goCompany(item) {
      console.log(item)
      this.$router.push("/products-mobile/" + this.lang + '?id=' + item._id)
    },
    async getCompanyList() { //目前处理 ：公司部分多个 语言版本，所有语言内置在 公司详情内 ，后台创建的公司默认都是  zh
      const res = await this.$http.post('companyList', { la: 'zh' })
      this.companyList = res.data || []
      console.log(this.companyList)
    },
    async getCompanyInfo() {
      const res = await this.$http.post('groupInfoList', { la: this.lang, type: 0 })
      this.detailCompanyInfo = res.data[0] || {}
    },
    async getFontConfig() {
      const res = await this.$http.post('fontConfig')
      const fontContent = res.data
      if (fontContent.length !== 0) {
        this.font = fontContent[0]

      }
    },
    getDetail(news) {
      this.$router.push({path:"/news-detail-mobile/"+this.lang,query:{id:news._id}})
    },
    async getImage() {
      const res = await this.$http.post('/indexConfig', { la: this.lang })
      this.indexConfig = res.data || {}
      this.allColor = this.indexConfig.allColor
      this.dataList = this.indexConfig.imageList
      this.dataList.forEach((item, index) => {
        if (index === 0) {
          this.$set(item, 'show', true)
        } else {
          this.$set(item, 'show', false)
        }

      })
      // this.dataList.push({videoUrl:'https://26106453.s21v.faiusr.com/58/ABUIABA6GAAgwpqxmAYog62x8AY.mp4'})
      this.bdColor = this.indexConfig.companInfo.backgroundColor
      console.log(this.indexConfig)
    },
  }

}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 1.3s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  transform: translateX(300px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-300px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.home-page-bd {
  width: 100%;
  padding: 0 0 2rem 0;
  box-sizing: border-box;

  .image-list{
				width: 100%;
        padding: .2rem .32rem;
        box-sizing: border-box;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				.one-img{
					float: left;
					    width: 48%;
						margin-right: 3px;
						margin-bottom: 3px;
						border-radius: 4px;
						overflow: hidden;
					img{
						display: block;
						object-fit: cover;
						width: 100%;
						height: 100%;
					}
				}
				
			}
  .new-content {
    .header-c {
      margin-bottom: .32rem;
      line-height: .8rem;
      max-width: 2.6rem;
    }

    .news {

      .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .company-image {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .new-content {
    padding: .32rem;
    box-sizing: border-box;
  }

  .info-wrap {
    padding: .32rem;
    box-sizing: border-box;
    margin-top: .3rem;

    .info {
      margin-bottom: .32rem;
    }
  }

  .item-wrap {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .item {
      display: inline-block;
      margin-left: .2rem;
      background: #f2f2f2;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      width: .3rem;
      height: .3rem;
      border: .04rem solid #262626;
    }

    .on {
      background: #ff121e;
      border: 2px solid #ff121e;
    }
  }

  .company-c {
    height: 4rem;
    background: #fff;
    position: relative;
    margin: -1.1rem 0.42rem 0 0.42rem;
    border-radius: .04rem;
    box-shadow: 3px 0 16px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }

  .company-name {
    color: #262626;
    font-weight: 600;
    text-align: center;
    line-height: .8rem;
  }

  .banner {
    width: 100%;
    height: 7rem;
    // height: 36.5vw;
    position: relative;
    overflow: hidden;

    .image-text {}

    .item {
      height: 100%;
      position: absolute;
      top: 0;

    }


    .pic {
      -webkit-animation-name: animateImg;
      -webkit-animation-timing-function: ease-in-out;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 12s;
      -webkit-animation-direction: alternate;
    }

    @keyframes animateImg {
      0% {
        opacity: 1;
      }

      25% {
        opacity: 0;
      }

      50% {
        opacity: 0;
      }

      75% {
        opacity: 1;
      }
    }
  }

  .van-swip {
    height: 100%;

    img {
      display: block;
      width: 100%;
      height: 100%;
      border: 2px solid white;
      -webkit-box-sizing: border-box;
      -ms-box-sizing: border-box;
      -o-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-transition: all 0.5s ease 0s;
      transition: all 0.5s ease 0s;
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    img:hover {
      -webkit-transition: all 0.5s ease 0s;
      -moz-transition: all 0.5s ease 0s;
      -o-transition: all 0.5s ease 0s;
      -ms-transition: all 0.5s ease 0s;
      transition: all 0.5s ease 0s;
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }
  }

  /deep/.van-swipe__track {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    height: 100%;
  }

  /deep/.van-swipe__indicators {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    position: absolute;
    left: 50%;
    bottom: 10px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  // .van-swip {
  //   position: relative;
  //   overflow: hidden;
  //   -webkit-transform: translateZ(0);
  //   transform: translateZ(0);
  //   cursor: grab;
  //   -webkit-user-select: none;
  //   user-select: none;

  // }
  .custom-indicator {}

  .van-swipe-item {}
}
</style>
